import useRemoteBoundStore from 'src/store/useRemoteBoundStore';

interface CameraPreviewColumnProps {
  isExpanded: boolean;
}

const CameraPreviewColumn = ({ isExpanded }: CameraPreviewColumnProps) => {
  const { cameraData } = useRemoteBoundStore();

  return (
    <div
      style={{
        flex: isExpanded ? '0' : '1',
        width: isExpanded ? '0' : 'auto',
        overflow: 'hidden',
        transition: 'flex 0.5s ease-in-out, width 0.5s ease-in-out',
      }}
    >
      <div>
        <iframe
          src={cameraData ? `http://${cameraData.ip}:8080/streamer` : ''}
          className="camera-preview"
          title="Preview"
        />
      </div>
    </div>
  );
};

export default CameraPreviewColumn;
